import React from "react";
import Skills from "../../components/skills/Skills";
import "./SkillContent.css";

const SkillContent = () => {
  return (
    <div className="SkillContent">
      <div className="skillHeading">
        <h3>Skills :</h3>
      </div>
      <div className="SkillText">
        <div className="item">
          <Skills text="Java" />
        </div>
        <div className="item">
          <Skills text="Javascript/React" />
        </div>
        <div className="item">
          <Skills text="CSS" />
        </div>
        <div className="item">
          <Skills text="SpringBoot" />
        </div>
        <div className="item">
          <Skills text="Kafka" />
        </div>
        <div className="item">
          <Skills text="Microservices" />
        </div>
        <div className="item">
          <Skills text="Git" />
        </div>
        <div className="item">
          <Skills text="Jenkins" />
        </div>
        <div className="item">
          <Skills text="ELK ( Elastic Stack )" />
        </div>
        <div className="item">
          <Skills text="AWS" />
        </div>
        <div className="item">
          <Skills text="SQL" />
        </div>
        <div className="item">
          <Skills text="MariaDB" />
        </div>
        <div className="item">
          <Skills text="Postman" />
        </div>
        <div className="item">
          <Skills text="kubectl" />
        </div>
      </div>
    </div>
  );
};

export default SkillContent;
